export const localeFallbacks = {"de":"en","en":null,"es":"en"};
